module.exports = __webpack_public_path__ + "static/media/fintechgalaxy.80623892.jpeg";